package com.partejar.app.feature.modeloscontrato.data

data class ModeloContrato(val id: Long, val name: String, val active: Boolean, val version: Int, val content: String)
data class ModeloContratoInput(val name: String, val active: Boolean, val content: String)
data class TemplateVariable(val group: String, val label: String, val placeholder: String)
interface ModelosContratoDataSource {
    suspend fun list(): List<ModeloContrato>
    suspend fun get(id: Long): ModeloContrato
    suspend fun create(input: ModeloContratoInput): ModeloContrato
    suspend fun update(id: Long, input: ModeloContratoInput): ModeloContrato
    suspend fun variables(): List<TemplateVariable>
}
open class ModelosContratoDataException(cause: Throwable? = null) : Exception(cause)
class ModelosContratoAccessException : ModelosContratoDataException()
class ModelosContratoUnavailableException(cause: Throwable? = null) : ModelosContratoDataException(cause)
